import * as stylex from "@stylexjs/stylex";
import { breakpoints, layoutAreas } from "../../materials/consts.stylex";
const BMBFSponsoredLogoDe = new URL("../../assets/bg_bmbf-sponsored_de.svg", import.meta.url).href;
const BMBFSponsoredLogoEn = new URL("../../assets/bg_bmbf-sponsored_en.svg", import.meta.url).href;
export const FederalMinistryGermanyLogo = ({ lang })=>{
    const logo = {
        de: BMBFSponsoredLogoDe,
        en: BMBFSponsoredLogoEn
    };
    return <div className="x1uq3dmu x1miatn0 x1nzp7vu x1gan7if xmum33x x1uhho1l x1xpa7k">
      <img alt="" src={logo[lang || "en"] || BMBFSponsoredLogoEn} className="xosgda"></img>
    </div>;
};
